export default {
    name: '中文',
    emoji: {
        key: 'zh',
    },
    punctuation: {
        separator: '、',
    },
    time: {
        seconds: '秒',
        minutes: '分钟',
        yesterday: '昨天',
        morning: '凌晨',
        forenoon: '上午',
        noon: '中午',
        afternoon: '下午',
        evening: '晚上',
        week: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        format: 'YYYY年M月D日',
    },
    tips: {
        loading: '正在加载...',
        inputText: '请输入文字...',
        searching: '正在搜索...',
        searchEmpty: '没有搜索到 {{0}} 相关结果',
        msgboxTitle: '提示',
        msgboxSubmitText: '确定',
        departmentGroup: '部门',
        companyGroup: '公司',
        allMemberGroup: '全员',
        contain: '包含: ',
        fileUnexist: '文件不存在',
        uploadAvatar: '头像正在上传中',
        groupDismissed: '该群组被解散',
        pwdTip: '6-16 位数字和字母组合',
        publish: '发布',
        clearApprove: '确定清空入群申请列表？',
        zeroSize: '不能发送大小为 0 KB 的文件',
        overSize: '发送的文件不能大于 {{0}}',
        recalled: '消息已被撤回',
        mostMembers: '最多可选择 {{0}} 人',
        voiceForward: '收藏的语音消息不能转发',
        collected: '已收藏',
        noMoreInfo: '没有更多信息，请检查你的网络设置',
        tipUpdateVersion: ' 检测到新的客户端版本，是否下载？',
        tipForceUpdate: '当前版本已不可用，请下载新版本！',
        downloadAndExit: '下载并退出',
    },
    btns: {
        refresh: '刷新',
        transfer: '转让',
        edit: '编辑',
        send: '发送',
        startConversation: '发起会话',
        save: '保存',
        saveAs: '另存为',
        full: '全屏',
        normal: '退出全屏',
        prev: '上一张',
        next: '下一张',
        prevPage: '上一页',
        nextPage: '下一页',
        reg: '注册',
        login: '登录',
        logining: '登录中...',
        logout: '退出登录',
        rememberMe: '自动登录',
        forget: '忘记密码',
        remove: '删除',
        removeConversation: '删除会话',
        cancel: '取消',
        close: '关闭',
        confirm: '确定',
        back: '返回',
        collapse: '收起',
        more: '查看全部',
        checkedAll: '全选',
        clear: '清空',
        search: '搜索',
        searchPerson: '搜索名称、手机号、邮箱',
        searchDuty: '搜索职位名称',
        searchOrg: '搜索组织架构名称',
        expand: '展开',
        recall: '撤回',
        copy: '复制',
        collect: '收藏',
        forward: '转发',
        untop: '取消置顶',
        top: '置顶',
        mute: '消息免打扰',
        unmute: '允许消息通知',
        draft: '草稿',
        saveContact: '保存到通讯录',
        add: '添加',
        inferior: '下级',
        zoomOut: '缩小',
        zoomIn: '放大',
        selectFile: '本地上传',
        groupChat: '发起群聊',
        addFriend: '添加好友',
        createGroup: '创建群组',
        maximize: '最大化',
        minimize: '最小化',
        restore: '还原',
        download: '下载',
        view: '查看',
        removeQuit: '删除并退出',
        confirmReply: '确认并回复',
        newPin: '新建 PIN',
        publish: '发布',
        ignore: '忽略此次更新',
        remindLater: '以后提醒我',
        upgrade: '立即更新',
        saveToLocal: '保存到本地',
        quote: '引用',
        resumeUpload: '继续上传',
        resumDownload: '继续下载',
    },
    contact: {
        department: '部门',
        subcompany: '子公司',
        contact: '联系人',
        group: '群组',
        app: '应用',
        orgContact: '企业通讯录',
        addressList: '企业通讯录',
        star: '星标联系人',
        friend: '我的好友',
        recent: '最近聊天',
        selectedMember: '已选择联系人（{{0}}）',
        emptyMember: '请选择需要添加的联系人',
        expandDept: '下级',
        person: '{{0}} 人',
        personSingle: '{{0}} 人',
        myGroup: '我的群组',
    },
    conversation: {
        draft: '草稿',
        mute: '消息免打扰',
        atme: '有人@我',
        messageSentFail: '消息发送失败',
        empty: '暂无会话',
    },
    message: {
        requestFriendVerification:
            '你还不是他（她）好友。请先发送好友验证请求，对方验证通过后，才能聊天。',
        requestFriendVerificationButton: '发送好友验证',
        readAll: '阅读全文',
        unknown: '当前版本暂不支持查看此消息',
        read: '已读',
        unread: '未读',
        checkUnread: '查看未读',
        allRead: '全部已读',
        unreadMember: '{{0}} 人未读',
        unreadMessageCount: '{{0}} 条未读消息',
        // 以下为群信息提示
        self: '你',
        create: '{{0}} 创建了群组',
        created: '{{0}}创建了群组',
        join: '{{0}} 加入群组',
        joinByQRCode: '{{0}} 通过扫描 {{1}} 分享的二维码加入该群',
        invite: '{{0}} 邀请 {{1}} 加入群组',
        invited: '{{0}}邀请 {{1}} 加入群组',
        inviteMe: '{{0}} 邀请{{1}}加入群组',
        kick: '{{0}}将 {{1}} 移出群组',
        kicked: '{{1}}被 {{0}} 移出群组',
        rename: '{{0}} 修改群名称为"{{2}}"',
        renamed: '{{0}}修改群名称为"{{2}}"',
        quit: '{{0}} 退出了群组',
        dismiss: '该群组已被解散',
        notice: '{{0}} 清空了群公告',
        noticeTitle: '群公告',
        OpenMute: '群主已开启“全员禁言”',
        CloseMute: '群主已关闭“全员禁言”',
        addMute: '{{1}} 已被群主禁言',
        removeMute: '{{1}} 已被群主解除禁言',
        updateManager: '{{1}} 成为新群主',
        updateManagerSelf: '{{1}}成为新群主',
        unSupport: '不支持操作类型',
        // 以下为部门群信息提示
        createDepartment: '欢迎加入 {{2}}',
        joinDepartment: '欢迎 {{1}} 加入 {{2}}',
        joinDepartmentSelf: '欢迎加入 {{2}}',
        departmentInvite: '欢迎 {{1}} 加入 {{2}}',
        departmentInviteSelf: '欢迎加入 {{2}}',
        KickDepartment: '{{1}} 被移出群组',
        KickedDepartment: '你被移出了群组',
        dismissDepartment: '该{{3}}群组已被解散',
        renameDepartment: '群名称被修改为 {{2}}',
        updateDepartmentManager: '{{1}} 已成为新群主',
        updateDepartmentManagerSelf: '{{1}}已成为新群主',
        // 以下位好友验证通过后,聊天页面的提示信息
        passed: '{{0}} 通过了你的好友验证请求，现在可以开始聊天了',
        pass: '你通过了 {{0}} 的验证请求，现在可以开始聊天了',
        recallSelf: '你撤回了一条消息',
        recallOther: '{{0}} 撤回了一条消息',
        recallAdmin: '消息被管理员撤回',
        cardSelf: '你推荐了 {{0}}',
        cardOther: '向你推荐了 {{0}}',
        redPacketSent: '[云红包]发出红包，请在手机上查看',
        redPacketReceived: '[云红包]收到红包，请在手机上查看',
        redPacketOpened: '{{0}} 领取了你的红包',
        youOpenedRedpack: '你领取了 {{0}} 的红包',
        youOpenedRedpackOfYouSent: '你领取了自己的红包',
        prefix: {
            ImageMessage: '[图片]',
            GIFImageMessage: '[图片]',
            LocalImageMessage: '[图片]',
            VoiceMessage: '[语音]',
            LocationMessage: '[位置]',
            FileMessage: '[文件]',
            LocalFileMessage: '[文件]',
            SightMessage: '[小视频]',
            RichContentMessage: '[图文]',
            AudioMessage: '[语音通话]',
            VideoMessage: '[视频通话]',
            ShareScreenMessage: '[屏幕共享]',
            ApprovalMessage: '[审批]',
        },
        recallEdit: '重新编辑',
    },
    user: {
        mobile: '手机',
        staffNo: '工号',
        signTel: '手机号',
        tel: '电话',
        email: '邮箱',
        deptName: '部门',
        dutyName: '职位',
        supervisorName: '上级',
        password: '密码',
        nickName: '昵称',
        account: '登录名',
    },
    pin: {
        send: '我发出的',
        receive: '我收到的',
    },
    updater: {
        status: {
            prepared: '新版本更新',
            finished: '已更新到最新版',
            failed: '更新出错',
            failedResult: '升级失败，请点击“立即更新”重试！',
        },
        updateProcess: {
            downloading: '正在下载更新包，请耐心等待（ {{0}}% ）',
            updating: '安装更新中（ {{0}}% ）',
            finished: '安装完成',
        },
    },
    emptyMessage: {
        pin: '暂无 PIN 消息',
        star: '暂无星标联系人',
        newFriend: '暂无好友请求',
        friend: '暂无好友',
        group: '暂无群组',
        conversation: '暂无会话',
        approve: '暂无入群申请',
    },
    voip: {
        shareScreen: '屏幕共享',
        audio: '语音通话',
        video: '视频通话',
        unAccept: '未接听',
        end: '已结束',
        audioTip: '正在语音通话中！',
        videoTip: '正在视频通话中！',
        shareScreenTip: '正在屏幕共享中！',
        summaryCodeMap: {
            1: '已取消',
            2: '已拒绝',
            3: '通话时长 ',
            4: '己方忙碌',
            5: '未接听',
            6: '己方不支持当前引擎',
            7: '己方网络出错',
            8: '其他设备已处理',
            11: '对方已取消',
            12: '对方已拒绝',
            13: '通话时长 ',
            14: '对方忙碌中',
            15: '对方无应答',
            16: '对方不支持当前引擎',
            17: '对方网络错误',
            18: 'voip 不可用',
        },
    },
    components: {
        upgrade: {
            title: '升级版本',
        },
        appversion: {
            title: '功能介绍',
            show: '查看',
        },
        getFileHelper: {
            title: '文件小助手',
            desc: '可以在手机与电脑间互传文件与消息',
            prompt: '可以在手机与电脑间互传文件与消息',
            start: '发起会话',
        },
        groupTransfer: {
            title: '选择新群主',
            message: '确定选择 {{0}} 为新群主，你将自动放弃群主身份？',
        },
        groupBanned: {
            title: '选择联系人',
            bannedAll: '全员禁言',
            silenterMembers: '被禁言成员',
            speakerMembers: '可发言成员',
            banned: '你已经被群主禁言',
        },
        signup: {
            title: '注册',
            nickNameTip: '请输入昵称',
            mobileEmptyTip: '请输入手机号',
            mobileErrTip: '请检查手机号格式',
            captchaTip: '请输入验证码',
            captcha: '短信验证码',
            pwdTip: '请输入密码',
            pwdLenTip: '密码包含数字、字母，长度6-16位，区分大小写',
            pwdHasSpace: '密码不能包含空格',
            sendCaptcha: '发送验证码',
            // 界面布局原因这里使用英文括号比较合适
            sentCaptcha: '已发送 ({{0}})',
        },
        login: {
            scanLogin: '扫码登录',
            pwdLogin: '密码登录',
            QRCodeExpired: '您的二维码已经失效，',
            refreshTip: '请点击下方的刷新按钮',
            scanTip: '请扫描二维码登录',
            refresh: '刷新',
            mobileEmptyTip: '请输入手机号',
            mobileErrTip: '请检查手机号格式',
            account: '请输入帐号',
            inputPwd: '请输入密码',
            accountEmptyTip: '请输入手机号/帐号',
            noPwdTip: '请输入密码',
            autoLogin: '自动登录',
            forgetPwd: '忘记密码',
            newRegisty: '新用户注册',
            clearStorageWarn:
                '帐号或密码错误，还有 1 次登录机会，如再次错误将清空本地数据',
        },
        search: {
            chatHistory: '聊天记录',
            resultHistory: '{{0}} 条相关聊天记录',
            resultHistoryDetail: '{{0}} 条与 {{1}} 相关聊天记录',
        },
        addFriend: {
            title: '添加好友',
            searchTip: '输入手机号/帐号',
            mobileEmptyTip: '请输入手机号',
            mobileErrTip: '请检查手机号格式',
            searchEmpty: '无法找到该用户，请检查输入帐号',
        },
        friends: {
            title: '我的好友',
        },
        contactGroup: {
            title: '我的群组',
        },
        contactApprove: {
            title: '入群申请',
        },
        contactList: {
            contactOrg: '组织架构',
            myDept: '我的部门',
            contactStar: '星标联系人',
            newFriend: '新的好友',
            contactFriend: '我的好友',
            contactGroup: '我的群组',
            contactApprove: '入群申请',
        },
        requestFriend: {
            title: '新的好友',
            accept: '接受',
            sent: '已发送',
            expired: '已过期',
            added: '已添加',
        },
        contactStar: {
            title: '星标联系人',
        },
        user: {
            editAvatar: '修改头像',
            removeFriend: '删除好友',
            addFriend: '添加好友',
            unsetStar: '取消星标联系人',
            setStar: '设为星标联系人',
            aliasEmpty: '添加备注名',
            removeFriendBefore: '将该好友删除，将同时删除与该好友的聊天记录。',
        },
        userRequest: {
            editAvatar: '修改头像',
            removeFriend: '删除好友',
            addFriend: '添加好友',
            unsetStar: '取消星标联系人',
            setStar: '设为星标联系人',
            aliasEmpty: '添加备注名',
            accept: '通过验证',
            removeFriendBefore: '将该好友删除，将同时删除与该好友的聊天记录！',
            requestInfo: '，请求加你为好友！',
        },
        verifyFriend: {
            title: '验证申请',
            tip: '你需要发送验证请求，对方通过后才能添加其好友。',
            iam: '我是',
        },
        ack: {
            title: '消息接收人详情',
            unreadMember: '{{0}}人未读',
            readMember: '{{0}}人已读',
        },
        atPanel: {
            everyone: '所有人',
        },
        card: {
            selected: '',
            empty: '',
        },
        conversationSetting: {
            title: '聊天设置',
            mute: '消息免打扰',
            top: '置顶聊天',
        },
        publicDetail: {
            title: '聊天设置',
            mute: '消息免打扰',
            top: '置顶聊天',
            enter: '进入应用',
        },
        conversation: {
            setting: '聊天设置',
            groupSetting: '群设置',
            groupNotice: '群公告',
            history: '历史消息',
        },
        forward: {
            forwarded: '已转发',
            forwardedFailed: '此消息已被撤回',
            success: '群主转让成功',
        },
        groupSetting: {
            title: '群设置',
            groupName: '群名称',
            admin: '群主',
            mute: '消息免打扰',
            top: '置顶聊天',
            saveContact: '保存到通讯录',
            member: '群成员',
            joinPermit: '入群验证',
            joinPermitMemo: '新成员需要群主验证同意，才能加入该群',
            banned: '群内禁言',
            bannedMemo: '可以设置全员禁言，也可以添加指定群成员不允许发言',
            setting: '设置',
            dismiss: '解散群组',
            groupAlias: '我在本群的昵称',
            unSetting: '未设置',
            groupAliasSetting: '设置你在此群的昵称，该昵称仅在此群内显示',
            quitMemo: '确认退出群组？',
            dismissMemo:
                '解散群组后, 所有群成员将失去群友联系，同时该群所有聊天图片、文件也将被永久删除',
            qrcode: '群二维码',
            onlyOwnerManage: '仅群主管理',
            onlyOwnerManageMemo: '启用后，其他成员不能添加群成员和编辑群公告',
        },
        groupNotice: {
            title: '群公告',
            sentTime: '发布时间',
            empty: '该群暂时没有群公告',
            inputText: '输入群公告内容',
            clear: '确定清空群公告？',
            edit: '编辑公告',
            new: '新建',
            cancel: '是否取消发布该条公告？',
            confirm:
                '该群公告将以 @所有人 的方式发送群消息，通知全部成员，是否发布？',
            onlyOwnerManage:
                '此群已开启仅群主可管理权限，当前仅群主可操作群公告”并跳转回“群公告',
        },
        groupQrcode: {
            tips: '扫一扫群二维码，立刻加入该群',
        },
        history: {
            title: '消息记录',
            all: '全部',
            file: '文件',
            image: '图片',
            empty: '暂无聊天记录',
        },
        messageInput: {
            emoji: '表情',
            screenshot: '截图',
            screenshotMaxSize: '发送的截图不能大于 {{0}}',
            sendFile: '发送文件',
            sendCard: '发送名片',
            hideWindow: '截屏时隐藏聊天窗口',
            zeroSize: '不能发送大小为 0 KB 的文件',
            banned: '禁言中',
            overSize: '发送的文件不能大于 {{0}}',
            voiceCall: '语音通话',
            videoCall: '视频通话',
        },
        previewImage: {
            title: '发送图片',
        },
        forgetPassword: {
            title: '重置密码',
        },
        stepPhone: {
            phone: '手机号',
            phoneEmpty: '请输入手机号',
            phoneInvalid: '请检查手机号格式',
            captchaEmpty: '请输入验证码',
            captcha: '验证码',
            sendCaptcha: '发送验证码',
            sentCaptcha: '已发送 ({{0}})',
            next: '下一步',
        },
        stepPassword: {
            passwordEmpty: '请输入密码',
            confirm: '完成',
            passwordInvalid: '密码长度为6-16位',
            newPassword: '新密码',
            tipPwd: '密码包含数字、字母，长度6-16位，区分大小写',
            enterNewPwd: '确认新密码',
            newPwdEmpty: '请再次输入密码',
            newPwdInvalid: '两次密码输入不一致',
        },
        stepSuccess: {
            title: '密码重置成功',
        },
        onlineStatus: {
            online: '在线',
            leave: '离开',
            busy: '忙碌',
            offline: '离线',
            mobile: '手机在线',
        },
        logout: {},
        welcome: {
            title: '| 融云企业版',
            motto: '新的一天 新的开始',
            contact: '通讯录',
            conversation: '会话',
            setup: '设置',
            pin: 'PIN',
            work: '工作台',
            collect: '收藏',
            sealRTC: '会议',
        },
        groupCreate: {
            groupName: '群名称',
            tip: '（非必填项）',
            createNotice: '群主已启用“入群验证”，群主同意邀请后才会进入群聊',
            createSuccess: '创建群成功',
            addMemberSuccess: '添加群成员成功',
            addMemberPermit: '成员邀请已发送',
            groupNameErr: '群名称不少于2个字',
            onlyOwnerManageTips:
                '此群已开启仅群主可管理权限，当前仅群主可添加群成员',
        },
        groupRemovemembers: {
            selectDelTip: '请选择需要删除的联系人',
            delMemberSuccess: '删除群成员成功',
            selectNone: '至少要选择1个成员',
        },
        fileMessage: {
            openFile: '打开文件',
            openFolder: '打开文件夹',
            downloadFile: '下载文件',
            cancelled: '已取消',
            cancel: '取消',
            cancelState: '已取消',
            downloadState: '正在下载',
            receiveState: '已接收',
            sendingState: '正在发送',
            sentState: '已发送',
            expiredState: '已失效',
        },
        cardMessage: {
            businessCard: '个人名片',
        },
        approvalMessage: {
            content: '{{0}}向你提出了审批',
            pending: '审批中',
            passed: '审批通过',
            refused: '审批拒绝',
            remind: '请及时审批',
            startTime: '开始时间',
            endTime: '结束时间',
            title: '审批',
        },
        quoteMessage: {
            file: '文件',
            link: '链接',
        },
        unknownMessage: {
            notSupport: '当前版本暂不支持查看此消息',
        },
        setting: {
            title: '设置',
            account: '帐号设置',
            password: '密码设置',
            system: '系统设置',
            about: '关于',
        },
        settingAccount: {
            mobile: '手机号：',
            quitTitle: '退出登录',
            quitMessage: '是否确定退出当前帐号',
            errorMessage: '16个字符以内',
            transfiniteMessage: '姓名仅支持中英文和数字',
        },
        settingSystem: {
            sysMsgNotify: '系统消息通知提示音',
            checkUpdate: '检查更新',
            language: '语言设置',
            majorCompany: '主企业',
            autoStart: '开机时自动启动 {{0}}',
            previewText: '通知显示消息详情',
            notifyText: '你收到一条新消息',
            atText: '{{0}}在群聊中@了你',
            shortcuts: '快捷键',
            searchShortcut: '搜索快捷键',
            screenshotShortcut: '截图快捷键',
            sendMessageShortcut: '发送消息快捷键',
            sendShortcutWin: 'Enter 发送，Shift + Enter 换行',
            sendShortcutMac: 'Return 发送，Shift + Return 换行',
        },
        settingAbout: {
            versionInfo: '版本信息',
        },
        settingPassword: {
            oldPwd: '原密码：',
            newPwd: '新密码：',
            confirmPwd: '确认密码：',
            tipOldPwd: '请输入原密码',
            tipNewPwd: '请输入新密码',
            tipPwdLen: '密码长度为6-16位',
            tipPwd: '密码包含数字、字母，长度6-16位，区分大小写',
            tipConfirmPwd: '请再次输入密码',
            tipMatchPwd: '两次密码输入不一致',
            errorCode: {
                10101: '原密码错误',
            },
        },
        setPassword: {
            safe: '为了您的帐户安全请您',
            modify: '修改登录密码',
            newPwd: '新密码：',
            confirmPwd: '确认密码：',
            tipNewPwd: '请输入新密码',
            tipPwdLen: '6-16位字母和数字组合',
            tipPwd: '密码包含数字、字母，长度6-16位，区分大小写',
            tipConfirmPwd: '请再次输入密码',
            tipMatchPwd: '两次密码输入不一致',
            confirm: '确认',
        },
        editAvatar: {
            selectPic: '请选择图片',
            getAvatarTokenErr: '获取上传 token 失败',
        },
        status: {
            netErr: '当前网络不可用，请检查你的网络设置',
        },
        newPin: {
            contact: '星标联系人',
            addressList: '企业通讯录',
            friend: '我的好友',
            selectedContact: '已选择联系人 ({{0}})',
            content: '内容',
            attaCount: '{{0}}个附件',
            addAtta: '添加附件',
            sendTime: '发送时间',
            immediatelySend: '立即发送',
            specificSend: '在指定时间发送',
            sendType: '发送方式',
            sms: '短信',
            app: '应用内',
            uploading: '文件正在上传中',
            pastTime: '不能选择过去的时间',
            mostReceive: '最多可选择 {{0}} 人，请删减人员后重试',
            mostAtta: '最多只能添加十个附件',
            success: '发送成功',
            mostContent: '最多只能输入5000字的内容',
            year: '年',
            month: '月',
            day: '日',
            hour: '时',
            minute: '分',
            failSend: '附件中有未上传完成文件不能发送',
        },
        addAttachment: {
            title: '添加附件',
            add: '添加附件',
            sendFaild: '发送失败',
            uploadFaild: '上传失败',
            renewDownload: '重新上传',
            resumeUpload: '继续上传',
            uploaded: '已上传',
            uploading: '正在上传',
            cancelled: '已取消',
            expired: '已失效',
        },
        addReceiver: {
            selectedContact: '已选择联系人 ({{0}})',
            selectedPrompt: '请选择需要添加的联系人',
            addSuccess: '加入成功',
        },
        receivedPin: {
            title: '我收到的 PIN',
            confirmed: '已确认',
            unConfirmed: '未确认',
            reply: '回复( {{0}} )',
            replyNone: '回复',
            confirmReceived: '确认收到',
            emptyPin: '暂无 PIN 消息',
        },
        sendPin: {
            title: '我发出的 PIN',
            unConfirmed: '{{0}}人未确认',
        },
        pinDetail: {
            title: 'PIN 详情',
            confirmed: '已确认 ({{0}})',
            unConfirmed: '未确认 ({{0}})',
            confirmDetail: '确认详情',
            receiver: '接收人',
            input: '请输入回复内容',
            unConfirmedCount: '{{0}}人未确认',
            inputCanNotEmpty: '回复内容不能为空',
            allConfirmed: '全部确认',
            webRtcTip: '请在PC客户端或手机客户端上使用此功能!',
        },
        approve: {
            wait: '通过',
            already: '已通过',
            overdue: '已过期',
            invalid: '已失效',
            applyto: '申请加入',
            inviter: '邀请人',
        },
        upgradeSuccess: {
            tips: '升级完成！',
        },
        upgradeFailed: {
            tips: '升级失败，请点击“升级更新”重试！',
        },
        upgradeUpgrading: {
            tips: '升级完成 {{0}}%',
        },
        upgradeDetail: {
            version: '{{0}} 版本',
            feature: '新版本特性',
        },
        device: {
            tips: '电脑端已被锁定',
            note: '你可以在手机端会话列表顶部状态栏解锁',
            button: '在手机上解锁',
            locked: '设备已被锁定',
            erase: '管理员擦除该帐号本地信息，请重新登录',
        },
        collect: {
            all: '全部收藏',
            text: '文本',
            voice: '语音',
            position: '位置',
            video: '图片及视频',
            file: '文件',
            link: '链接',
            collected: '收藏于',
            second: '秒',
            null: '当前没有收藏',
            allCollect: '全部',
        },
        public: {
            tips: '此应用已关闭，暂时无法使用',
        },
        syncdataLoading: {
            failed: '数据更新异常，请重试',
            completed: '数据更新完毕',
            process: '数据正在更新，请耐心等待…',
        },
        voipInvitemember: {
            selectedMember: '已选成员（{{0}}）',
            audioMaxError: '音频通话最多支持 {{0}} 人',
            videoMaxError: '视频通话最多支持 {{0}} 人',
            audioMaxWarn:
                '音频通话最多支持 {{0}} 人，后续加入者以观察者身份加入',
            videoMaxWarn:
                '视频通话最多支持 {{0}} 人，后续加入者以观察者身份加入',
        },
        sealRTC: {
            title: '发起一个会议',
            subject: '会议主题',
            id: '会议室ID',
            startTime: '开始时间',
            inviteUsers: '邀请参会人员',
            invitedUsers: '已邀请({{0}})人',
            sendMessage: '发送邀请消息',
            directJoin: '直接加入',
            sendButton: '发送邀请信息',
            directJoinButton: '会议已存在,直接加入',
            clickLink: '，点击链接可直接参会。',
            pinTitle: 'PIN的内容：邀请您参加线上会议',
            subjectPlaceholder: '请输入会议名称',
            idPlaceholder: '请输入会议ID',
            metting: '的会议',
            subjectRule: '请输入1到30位的字符',
            rtcRule: '请输入1到30位的数字，字母 -的组合',
            sendPinSuccess: '已发送',
            now: '现在',
            mostReceive: '最多可选择 {{0}} 人，请删减人员后重试',
            onlyOneRTC: '您当前已有一个正在进行中的音视频会议，是否立即关闭启动新会议？',
        },
    },
    errorCode: {
        'logout-by-otherclient': '您的PC端已退出登录',
        'kicked-offline-by-otherclient': '您的帐号已经在其他设备登录',
        'user-be-blocked': '用户被封禁',
        'user-status-updated': '欢迎加入 {{0}}，请重新登录',
        'unknown-error': '未知错误',

        'old-password-error': '原密码错误',
        'new-password-same-old-password': '新密码不能与旧密码一致，请重试',
        'password-changed': '密码已修改，请重新登录！',
        'account-changed': '登录帐号已修改，请重新登录',
        'password-overtime': '密码已过期',

        'message-recall-timeout': '撤回失败，该消息的发送时间超过 3 分钟！',

        'network-error': '网络错误',
        'request-data-failed': '网络错误，获取数据失败',
        'request-failed': '网络请求失败',

        'invalid-config': '未能从config.js里取得appkey或server',
        'invalid-token': '无效的token',
        'require-captcha': '请先获取验证码',

        'card-limit': '单次只能发送一张名片',

        'forward-limit': '转发消息数量不能超过10个聊天',

        'download-interrupted': '下载中断',
        'download-cancelled': '已取消下载',
        'download-error': '下载失败',
        'download-ebusy': '文件被其他程序占用',
        'download-eperm': '无文件写入权限',

        'upload-error': '上传失败',
        'upload-timeout': '上传超时',

        'file-404': '本地文件不存在或已被删除',
        'file-error': '本地文件获取失败',

        'status-1': '连接中',
        'status-2': '连接已断开',
        'status-3': '网络不可用',
        'status-4': '连接已关闭',
        'status-6': '帐号在其他设备已登录',
        'status-12': '域名不正确',
        'status-13': '用户被封禁',

        'contact-1': '至少要选择1个成员',
        'contact-2': '创建群成功',
        'contact-3': '删除成员成功',
        'contact-4': '添加成员成功',
        'contact-5': '退出群成功',
        'contact-6': '解散群成功',

        'lib--1': '请求超时',
        'lib--2': '未知错误',
        'lib-7': '网络不可用',
        'lib-20604': '发送频率过快',
        'lib-22406': '您当前不在此群组',
        'lib-21501': '消息被敏感词拦截',
        'lib-21502': '消息被敏感词替换',

        10001: '权限不足',
        10002: '不支持',
        // '10003': '一般错误',
        10004: '功能未实现',
        10005: '服务端异常',
        10006: '无效的请求参数',
        10009: '超过发送次数，请稍后重试!',
        15001: '超过发送次数，请稍后重试!',

        '10101-4': '帐号或密码错误，请重新输入',
        '10101-3': '帐号或密码错误，还有 3 次登录机会',
        '10101-2': '帐号或密码错误，还有 2 次登录机会',
        '10101-1': '帐号或密码错误，还有 1 次登录机会',

        10100: '帐号不存在，请重新输入',
        10101: '帐号或密码错误，请重新输入',
        10102: '用户未登录或登录信息过期',
        10103: '密码格式不对',
        10104: '昵称不能为空',
        10105: '昵称超过最大长度',
        10106: '头像URL不能为空',
        10107: '头像URL超过最大长度',
        10108: '用户未登录或登录信息过期',
        10109: '用户名为空',
        10110: '用户密码为空',
        10111: '帐号被禁用',
        10112: '获取token失败',
        10113: '用户id不能为空',
        10114: '密码不能为空',
        10115: '无效的手机号码',
        10116: '发送验证码频率过快',
        10117: '验证码已过期',
        10118: '请先发送验证码',
        10119: '请先校验验证码',
        10120: '验证码错误',
        10121: '用户已存在',
        10122: '登录token超时',
        10123: '登录token无效',
        10126: '原密码错误',
        10128: '帐号或密码多次错误，请 {{0}}后再试或点击忘记密码',
        10130: '手机号已存在',

        10200: '所请求部门不存在',
        10201: '部门名不能为空',
        10202: '无效的部门ID',
        10203: '上级部门未找到',
        10204: '非法的创建者ID',
        10205: '创建者ID未找到',
        10206: '无效的ManagerID',
        10207: 'Manager未找到',
        10208: '无效的部门成员ID',
        10209: '部门成员为空',
        102010: '已经存在的部门ID',

        // '10400': '不支持的排序类型',
        // can not add yourself
        10400: '不能加自己为好友',
        // request not exist
        10401: '目标联系人不存在',
        // friend not found
        10402: '朋友不存在',
        // request is timeout
        10403: '请求已过期',
        // friendship is created
        10404: '已是朋友关系',

        10500: '未知员工',
        10501: '员工姓名不能为空',
        10502: '员工名已经存在',
        10503: '员工邮箱不能为空',
        10504: '员工邮箱已经存在',
        10505: '无效的员工ID',
        10506: '员工ID已经存在',
        10507: '管理员不存在',
        10508: '请填写手机号码',
        10509: '手机号码已存在',

        10600: '所请求群组不存在',
        10601: '群名称不能为空',
        10602: '群名称长度超过限制',
        10603: '群成员总数超过限制',
        10604: '当前操作用户所能建立的群组个数超过限制',
        10605: '所请求群成员不存在',
        10606: '群成员已经存在',
        10607: '无效的群组ID',
        10608: '无效的群组成员ID',
        10609: '对应的部门未找到',
        10610: '无效的对应部门ID',
        10611: '缺少群组类型',
        10612: '群组ID已经存在',
        10613: '官方群已存在',
        10614: '公司不存在',
        10615: '无效的公司ID',
        10626: '此群已开启仅群主可管理权限，当前仅群主可添加群成员',
        10645: '群成员最多 {{0}} 人',

        10700: '公司未找到',
        10701: '无效的公司ID',
        10702: '公司ID已经存在',
        10703: '空的公司名',
        10704: '空的公司全名',
        10705: '空的群组名',
        10706: '官方群已存在',
        10707: '无官方群',

        10800: '无效的收藏群组ID',
        10801: '对应的群组未找到',
        10802: '收藏群组不存在',

        10900: '对应联系人未找到',
        10901: '收藏的联系人不存在',

        11000: '未找到scope',
        11001: '未找到名称',

        12000: '无效的话题',

        13000: '未找到职位信息',

        11400: '不在收件人列表',
        11401: '不是pin的创建者',
        11402: '未确认',
        11403: 'pin已经被删除',
        11404: 'pin已经发送',
        11405: 'pin还未发送',
        11410: 'pin参数无效',
        12302: '设备已被锁定',
    },
};
